import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchTickets } from "../features/tickets/ticketsThunks";
import '../App.css';

export default function Dashboard() {
  const dispacth = useDispatch();
  const { tickets } = useSelector((state) => state.tickets);

  useEffect(() => {
    dispacth(fetchTickets());
  }, [dispacth]);

  const priority = { low: 0, medium: 0, high: 0 };

  tickets.forEach((ticket) => {
    if (ticket.priority === "low") priority.low += 1;
    if (ticket.priority === "medium") priority.medium += 1;
    if (ticket.priority === "high") priority.high += 1;
  });

  return (
    <div className="container mt-4">
      <div className="container">
        <div className="row g-3">
          <div className=" col-md-3">
            <div className="card text-center">
              <div className="card-body">
                <h6>Total Applications</h6>
                <h4>{tickets.length}</h4>
              </div>
            </div>
          </div>

          <div className=" col-md-3">
            <div className="card text-center">
              <div className="card-body">
                <h6>Priority Low</h6>
                <h4>{priority.low}</h4>
              </div>
            </div>
          </div>

          <div className=" col-md-3">
            <div className="card text-center">
              <div className="card-body">
                <h6>Priority Medium</h6>
                <h4>{priority.medium}</h4>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card text-center">
              <div className="card-body">
                <h6>Priority High</h6>
                <h4>{priority.high}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /> <br></br>
      <h5>Recent Activity</h5>
      <hr />
      <div className="list-group">
        {tickets
          .slice(-5)
          .reverse()
          .map((ticket) => (
            <div
              key={ticket.id}
              className="list-group-item list-group-item-action mb-2"
            >
              <div className="d-flex w-100 justify-content-between">
                <h6 className="mb-1">{ticket.title}</h6>
                <small>{new Date(ticket.createdAt).toLocaleDateString()}</small>
              </div>
              <p className="mb-1">Priority: {ticket.priority}</p>
              <small>Status: {ticket.status}</small>
            </div>
          ))}
      </div>
    </div>
  );
}
